import { render, staticRenderFns } from "./WaitlistAdmin.vue?vue&type=template&id=8fa249b0&scoped=true&"
import script from "./WaitlistAdmin.vue?vue&type=script&lang=js&"
export * from "./WaitlistAdmin.vue?vue&type=script&lang=js&"
import style0 from "./WaitlistAdmin.vue?vue&type=style&index=0&id=8fa249b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa249b0",
  null
  
)

export default component.exports